import { AppResource } from "../../../../assets/AppResource";
import {
  EnvironmentOutlined,
  MailOutlined,
  PhoneOutlined,
} from "@ant-design/icons";

const Footer = () => {
  return (
    <div>
      <div
        style={{
          height: 300,
          backgroundImage: `url(${AppResource.backgroundFooter})`,
          backgroundPosition: "center",
          backgroundSize: "contain",
        }}
        className="grid grid-cols-12 text-white py-10"
      >
        <div className="col-span-3 flex flex-col space-y-4 items-center">
          <img
            src={AppResource.logo}
            style={{
              aspectRatio: 1,
              width: 120,
            }}
          />
          <h4 className="uppercase font-semibold">
            ©Quỹ xã hội và cộng đồng SCF
          </h4>
        </div>
        <div className="col-span-3" />
        <div className="col-span-6 flex flex-col text-xl space-y-4">
          <h4 className="font-bold text-3xl">Thông tin liên hệ</h4>
          <div className="w-1/6 h-[1px] bg-main"></div>
          <a href="#" className="space-x-2">
            <EnvironmentOutlined className="text-main" />
            <span>Trương Định Plaza, 461 Trương Định, Hoàng Mai, Hà Nội</span>
          </a>
          <a href="mailto:info@scf.asia" className="space-x-2">
            <MailOutlined className="text-main" />
            <span>info@scf.asia</span>
          </a>
          <a href="tel:+84981837406" className="space-x-2">
            <PhoneOutlined className="text-main" />
            <span>+84981837406</span>
          </a>
        </div>
      </div>

      <div className="bg-main w-100 font-semibold text-white text-center py-2">
        © Bản quyền nội dung thuộc về scf.asia
      </div>
    </div>
  );
};

export default Footer;
